class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function Generic(tp,pred,d){const f=(...args)=>{const t={description:d||'generic',__runtimeType:true,check:v=>pred(v,...args)};return t};f.__runtimeType=true;f.description=d;return f};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack,Type,Generic,FunctionPredicate};
/* tjs <- make-component.ts */

/*#
# makeComponent

`makeComponent(tag: string, bluePrint: XinBlueprint<T>): Promise<XinComponentSpec<T>>`
hydrates [blueprints](/blueprint-loader/) into usable [web-components](/component/).

Here are the relevant interfaces:

```
export interface PartsMap<T = Element> {
  [key: string]: T
}

export type XinBlueprint<T = PartsMap> = (
  tag: string,
  module: XinFactory
) => XinComponentSpec<T> | Promise<XinComponentSpec<T>>

export interface XinComponentSpec<T = PartsMap> {
  type: Component<T>
  lightStyleSpec?: XinStyleSheet
  styleSpec?: XinStyleSheet // deprecated, use lightStyleSpec
}
```

Note that a crucial benefit of blueprints is that the **consumer** of the blueprint gets
to choose the `tagName` of the custom-element.
*/

import { Color } from './color'

import { Component } from './component'

import { vars, varDefault } from './css'

import { XinStyleSheet } from './css-types'

import { bind, on } from './bind'

import { elements, svgElements, mathML } from './elements'

import { ElementCreator, PartsMap } from './xin-types'

import { version } from './version'

import { xin, boxed } from './xin'

import { xinProxy, tosi, boxedProxy } from './xin-proxy'

export const XinFactory = Type('XinFactory', undefined, { Color: undefined, Component: undefined, elements: undefined, svgElements: undefined, mathML: undefined, vars: undefined, varDefault: undefined, xin: undefined, boxed: undefined, xinProxy: undefined, boxedProxy: undefined, tosi: undefined, makeComponent: undefined, bind: undefined, on: undefined, version: '' })

export const XinComponentSpec = Generic([['T', null]], (x, checkT) => { return typeof x === 'object' && x !== null && 'type' in x && 'lightStyleSpec' in x && 'styleSpec' in x }, 'XinComponentSpec')

export const XinPackagedComponent = Generic([['T', null]], (x, checkT) => { return typeof x === 'object' && x !== null && 'type' in x && 'creator' in x }, 'XinPackagedComponent')

export const madeComponents = {};

export const XinBlueprint = FunctionPredicate('XinBlueprint', [['T', null]], (T) => ({ params: { tag: '', module: null }, returns: null }))

/* line 80 */
export async function makeComponent(tag,blueprint) {
  try {
  __tjs.pushStack('make-component.ts:63:makeComponent');
  if (tag instanceof Error) return tag;
  if (blueprint instanceof Error) return blueprint;
  if (typeof tag !== 'string') return __tjs.typeError('make-component.ts:63:makeComponent.tag', 'string', tag);

    const spec = (await blueprint(tag, {
        Color,
        Component,
        elements,
        svgElements,
        mathML,
        varDefault,
        vars,
        xin,
        boxed,
        xinProxy,
        boxedProxy,
        tosi,
        makeComponent,
        bind,
        on,
        version,
    }));
    const { type } = spec;
    type.preferredTagName = tag;
    const lightStyle = spec.lightStyleSpec ?? spec.styleSpec;
    if (lightStyle) {
        type.lightStyleSpec = lightStyle;
    }
    const packagedComponent = {
        type,
        creator: type.elementCreator(),
    };
    madeComponents[tag] = packagedComponent;
    return packagedComponent;

  } finally { __tjs.popStack(); }
}
makeComponent.__tjs = {
  "params": {
    "tag": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "blueprint": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    }
  },
  "source": "make-component.ts:63"
}